/**
 * @generated SignedSource<<8d4cddd9b013b5ed3fc3457a9bbcb235>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateTeamInput = {
  description?: string | null | undefined;
  generationDescription?: string | null | undefined;
  name: string;
};
export type CreateTeamRouteCreateTeamMutation$variables = {
  input: CreateTeamInput;
};
export type CreateTeamRouteCreateTeamMutation$data = {
  readonly createTeam: {
    readonly team: {
      readonly description: string | null | undefined;
      readonly id: any;
      readonly name: string;
    };
  };
};
export type CreateTeamRouteCreateTeamMutation = {
  response: CreateTeamRouteCreateTeamMutation$data;
  variables: CreateTeamRouteCreateTeamMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTeamPayload",
    "kind": "LinkedField",
    "name": "createTeam",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLTeam",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateTeamRouteCreateTeamMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateTeamRouteCreateTeamMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4c432aa364ed85a5bd33d0db9ac75c40",
    "id": null,
    "metadata": {},
    "name": "CreateTeamRouteCreateTeamMutation",
    "operationKind": "mutation",
    "text": "mutation CreateTeamRouteCreateTeamMutation(\n  $input: CreateTeamInput!\n) {\n  createTeam(input: $input) {\n    team {\n      id\n      name\n      description\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f4dbb788d6ccbafee8faa476aae7174b";

export default node;
